import styled from "styled-components"
import Div from "../components/div/div.component"
import { space } from "styled-system"

export const CoursesSection = styled.div`
  width: 100%;
  grid-column: 1 / -1;
  padding: 60px 60px 100px 60px;
  background-color: ${({ theme: { colors } }) => colors.lightGrey};

  @media screen and (max-width: 1200px){ 
    padding-left: 20px;
    padding-right: 20px;
  }

  @media screen and (max-width: 780px) {
    padding-top: 40px;
    padding-bottom: 60px;
  }
`

export const CourseCardsSection = styled(Div)`
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: auto;
  grid-gap: 30px;
  width: 100%;

  @media screen and (max-width: 950px){
    grid-gap: 20px;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
  }

  @media screen and (max-width: 780px) {
    grid-gap: 20px;
  }
`

export const ResultContainer = styled(Div)`
  display: flex;
`

export const CoursesContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 9fr;

  @media screen and (max-width: 1200px) {
    padding-left: 40px;
    padding-right: 40px;
  }

  @media screen and (max-width: 1100px) {
    grid-template-columns: 4fr 8fr;
  }

  @media screen and (max-width: 780px) {
    grid-template-columns: 1fr;
    padding-left: 0;
    padding-right: 0;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const SearchSortContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;

  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
`

export const ResultText = styled.span`
  /*display: inline-block;*/
  display: flex;
  margin: -5px 0 15px 0;
  ${({ theme: { typography } }) => typography.desktop.excerpt};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  color: ${({ theme: { colors } }) => colors.grey};
  align-self: center;
  ${space}
`

export const LabelContainer = styled.span`
  margin-left: 10px;
  color: ${({ theme: { colors } }) => colors.accentBlue};
  text-decoration: none;
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.bold};
  text-transform: uppercase;
  outline: none;
  &:after {
    content: "";
    display: block;
    width: 100%;
    height: 1px;
    position: relative;
    margin: 0 auto;
    top: 3px;
  }

  @media (hover: hover) {
    :hover {
      ::after {
        background-color: ${({ theme: { colors } }) => colors.accentBlue};
      }
    }
  }

  :active {
    ::after {
      background-color: ${({ theme: { colors } }) => colors.accentBlue};
    }
  }
  :focus-visible {
    ::after {
      background-color: ${({ theme: { colors } }) => colors.accentBlue};
      height: 2px;
      width: 100%;
    }
  }
`
export const SmallTextLinkContainer = styled.button`
  display: flex;
  cursor: pointer;
  font-size: 15px;
  align-self: center;
  border: none;
  background-color: ${(props) => props.isCoursesPage ? "rgb(246,246,251)" : "#fff"};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  outline: none;
  margin-left: 20px;
  padding: 0;
  svg {
    align-self: center;
  }
  :focus-visible {
    ${LabelContainer} {
      ::after {
        background-color: ${({ theme: { colors } }) => colors.accentBlue};
        height: 2px;
        width: 100%;
      }
    }
  }
`
